import gql from 'gql-tag'
import { BASE_COMMUNICATION_FRAGMENT } from 'fragments/communication.query'

export const GET_COMMENT_COMMUNICATIONS = gql`
  query GET_COMMENT_COMMUNICATIONS($taskRef: String!, $questionnaireRef: String!) {
    CommunicationList(based_on: $taskRef, part_of: $questionnaireRef) {
      ...BaseCommunication
    }
  }
  ${BASE_COMMUNICATION_FRAGMENT}
`
